import { render, staticRenderFns } from "./JSelectDash.vue?vue&type=template&id=1f4554d2&"
import script from "./JSelectDash.vue?vue&type=script&lang=js&"
export * from "./JSelectDash.vue?vue&type=script&lang=js&"
import style0 from "./JSelectDash.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports